import { useEffect } from "react";

import { CopyToClipboardButton } from "@/components/CopyToClipboardButton";
import { FullPageSpinner } from "@/components/Spinner";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useGameReport } from "@/routes/game/queries";
import { supportedLanguagesByCode } from "@/utils/i18n";
import { useLanguageCodeWithDefault } from "@/utils/language";

import { GameReportForm } from "./GameReportForm";

export const GameReport = ({ gameId }: { gameId: string }) => {
    const languageCode = useLanguageCodeWithDefault();
    const { game, loading, error, refetch } = useGameReport(gameId, languageCode);

    useEffect(() => {
        if (!loading && !error && !game) {
            const timeout = setTimeout(() => {
                refetch();
            }, 1000);
            return () => clearTimeout(timeout);
        }
    }, [loading, error, game, refetch]);

    if (error) {
        return <p>Error: {error.message}</p>;
    }

    if (loading || !game) {
        return <FullPageSpinner />;
    }

    return (
        <Card className="bg-brand-white text-brand-black m-4 rounded border-none">
            <CardHeader>
                <CardTitle>
                    {supportedLanguagesByCode[languageCode]} game report –{" "}
                    {game.whitePlayer.nickname} vs. {game.blackPlayer.nickname}
                </CardTitle>
                <div className="flex items-start justify-between">
                    <div className="flex flex-col">
                        {game.report?.id ? (
                            <div className="flex-row items-center">
                                <span className="text-sm">ID: {game.report?.id}</span>
                                <CopyToClipboardButton text={game.report?.id} />
                            </div>
                        ) : null}
                    </div>
                </div>
            </CardHeader>
            <CardContent>
                <GameReportForm gameId={game.id} gameReportFragment={game.report} />
            </CardContent>
        </Card>
    );
};
